
import styles from "./Footer.module.scss";

import facebook from './assets/facebook.svg';
import linkedin from './assets/linkedin.svg';
import twitter from './assets/twitter.svg';
import telegram from '../../assets/Imgs/telegram.svg'
import instagram from '../../assets/Imgs/instagram.svg'

const ICONS = {
    facebook: <img src={facebook} alt="facebook" title="facebook"></img>,
    linkedin: <img src={linkedin} alt="linkedin" title="linkedin"></img>,
    twitter: <img src={twitter} alt="twitter" title="twitter"></img>,
    telegram: <img src={telegram} alt="telegram" title="telegram" style={{ width: '24px', height: "24px" }}></img>,
    instagram: <img src={instagram} alt="instagram" title="instagram"></img>
};
const FooterSocialLinks = ({ landingJsonParsedFooter, communityFooterLinks }) => {
    const links = (communityFooterLinks || []).slice(0, 3);

    if (links.length > 0) {
        return (
            <div className={styles.social}>
                {links.map(link => {
                    return (
                        <a
                            key={link.url}
                            href={link.url}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {ICONS[link.type.toLowerCase()]}
                        </a>
                    )
                })}
            </div>);
    }

    return (
        <div className={styles.social}>
            {landingJsonParsedFooter.links.map(link => {
                return (
                    <a
                        key={link.url}
                        href={link.url}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {ICONS[link.icon]}
                    </a>
                )
            })}
        </div>);
}

export default FooterSocialLinks;